module.exports = __webpack_public_path__ + "img/COWP-Logo.416b7055.png";